import styled from 'styled-components';
import { LoadingButton } from '@mui/lab';
import { Typography } from '@mui/material';
import { colorsNeutrals, neutrals } from 'utils/styles/color';

export const ExportCSVButton = styled(LoadingButton)`
  && {
    font-family: Poppins, sans-serif;
    font-size: 0.813rem;
    font-weight: 500;
    line-height: 15.5px;
    text-align: left;
    text-decoration-line: underline;
    padding: 0;
  }
`;

export const StyledFilterItemLabel = styled(Typography)<{
  $disabled?: boolean;
}>`
  && {
    font-family: Poppins;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0%;
    vertical-align: middle;
    color: ${({ $disabled }) =>
      $disabled ? neutrals[500] : colorsNeutrals[700]} !important;
  }
`;

export const StyledFilterGrayText = styled(Typography)`
  && {
    font-family: Poppins;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0%;
    vertical-align: middle;
    color: ${neutrals[500]} !important;
  }
`;
